const transform = (venueTypes, generateUri, i18n) =>
  venueTypes.map((venueType) => {
    const id = venueType.id;
    const normalisedName = venueType.normalisedName;
    const title = venueType.name;
    const description = i18n(`page.venue-type.${id}.hero.description`);
    const image = venueType.image || {};
    const imageUri = Object.values(image.uris || {})[0];
    const uri = generateUri('venueType', { normalisedName });

    return {
      title,
      description,
      uri,
      imageUri,
    };
  });

export default transform;
